module.exports = __webpack_public_path__ + "static/img/video_ranking_list_avatar2.ff30dae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video_ranking_list_avatar2.png
// module id = /CKb
// module chunks = 1